import styled from 'styled-components';

export const Photo = styled.div`
  width: 100%;
  height: 268px;
  background-color: ${({ bgColor }) => bgColor};
  margin-bottom: 24px;
`;

export const Container = styled.div`

`;

export const Description = styled.div`
  height: 76px;
`;
